import { render, staticRenderFns } from "./AppSplash.vue?vue&type=template&id=7642500c&scoped=true"
import script from "./AppSplash.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSplash.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AppSplash.vue?vue&type=style&index=0&id=7642500c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7642500c",
  null
  
)

export default component.exports